import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './ProjectsBlock.css';

const projects = [
  {
    id: 1,
    slug: "modern-villa-electrical",
    name: "Modern Villa Electrical System",
    type: "Residential Installation",
    description: "Complete electrical design and installation for a luxury 5-bedroom villa with smart home integration, automated lighting, and energy management systems.",
    image: "/images/projects/project-1.jpg",
    category: "Residential"
  },
  {
    id: 2,
    slug: "commercial-solar-farm",
    name: "Commercial Solar Farm Setup",
    type: "Solar Systems",
    description: "50kW solar panel installation for commercial building with battery storage, inverter systems, and cloud-based monitoring platform.",
    image: "/images/projects/project-2.jpg",
    category: "Commercial"
  },
  {
    id: 3,
    slug: "factory-cctv-security",
    name: "Factory CCTV & Security Network",
    type: "Security Systems",
    description: "Comprehensive CCTV and alarm system with 64 cameras, motion detection, remote access, and 24/7 monitoring for industrial manufacturing facility.",
    image: "/images/projects/project-3.jpg",
    category: "Industrial"
  },
  {
    id: 4,
    slug: "hotel-network-infrastructure",
    name: "Hotel Network Infrastructure",
    type: "Network Installation",
    description: "High-speed internet backbone and structured cabling for 100-room hotel with enterprise-grade routers, access points, and network security.",
    image: "/images/projects/project-4.jpg",
    category: "Commercial"
  },
  {
    id: 5,
    slug: "estate-electric-fence",
    name: "Estate Electric Fence Project",
    type: "Security Systems",
    description: "Perimeter electric fence installation for 20-acre residential estate with access control gates, energizers, and alarm integration.",
    image: "/images/projects/project-5.jpg",
    category: "Residential"
  },
  {
    id: 6,
    slug: "apartment-electrical-design",
    name: "Apartment Electrical Design",
    type: "Electrical Designs",
    description: "Complete electrical planning, load calculations, and distribution design for 50-unit modern apartment complex with underground cabling.",
    image: "/images/projects/project-6.jpg",
    category: "Residential"
  }
];

const ProjectsBlock = () => {
  const [hoveredProject, setHoveredProject] = useState(null);
  const [activeCategory, setActiveCategory] = useState('All');
  const categories = ['All', 'Residential', 'Commercial', 'Industrial'];
  const filteredProjects = activeCategory === 'All' ? projects : projects.filter(p => p.category === activeCategory);

  return (
    <section className="projects-block">
      <div className="projects-block-container">
        <div className="projects-block-header">
          <h4 className="projects-block-subtitle">Our Projects</h4>
          <h1 className="projects-block-title">Showcasing Excellence In Every Project</h1>
          <p className="projects-block-description">Explore our portfolio of completed electrical and installation projects across residential, commercial, and industrial sectors.</p>
        </div>
        <div className="projects-tabs-wrapper">
          <div className="projects-tabs">
            {categories.map((cat) => (
              <button key={cat} className={`project-tab ${activeCategory === cat ? 'active' : ''}`} onClick={() => setActiveCategory(cat)}>{cat}</button>
            ))}
          </div>
        </div>
        <div className="projects-list">
          {filteredProjects.map((project) => (
            <div key={project.id} className={`project-row ${hoveredProject === project.id ? 'hovered' : ''}`} onMouseEnter={() => setHoveredProject(project.id)} onMouseLeave={() => setHoveredProject(null)}>
              <div className="project-row-bg" style={{ backgroundImage: `url(${process.env.PUBLIC_URL + project.image})` }} />
              <div className="project-row-overlay" />
              <div className="project-row-content">
                <div className="project-left">
                  <span className="project-number">{String(project.id).padStart(2, '0')}</span>
                  <h3 className="project-row-name">{project.name}</h3>
                  <span className="project-tag">{project.type}</span>
                </div>
                <div className="project-right">
                  <p className={`project-row-description ${hoveredProject === project.id ? 'visible' : ''}`}>{project.description}</p>
                  <Link to={`/projects/${project.slug}`} className={`project-row-btn ${hoveredProject === project.id ? 'visible' : ''}`}>View Project →</Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProjectsBlock;
